import { AxiosResponse } from 'axios';
import { useAuth } from 'core/contexts';
import {
    withHeaders,
    instance as axiosInstance,
} from 'core/util/axiosInstance';
import { getDefaultHeaders } from 'core/util/other';
import { useQuery, UseQueryResult } from 'react-query';

export const useSystemMessageDetailsQueryProps = {
    enabled: false,
    retry: false,
    refetchOnWindowFocus: false,
};

const fetchSystemMessageDetails = async (
    url: string,
    token: string
): Promise<AxiosResponse<any, any>> => {
    const headers = getDefaultHeaders(token);
    const response = await axiosInstance().get(url, withHeaders(headers));
    return response;
};

export const useSystemMessageDetails = (
    props: any
): UseQueryResult<AxiosResponse<any, any>, unknown> => {
    const { getToken } = useAuth();
    const { systemMessageId, queryProps } = props;

    const url = `/message/${systemMessageId}`;
    return useQuery(
        `system-message-details-${systemMessageId}`,
        async () => fetchSystemMessageDetails(url, getToken()),
        queryProps
    );
};
